import { Button } from 'antd';
import { StrikethroughOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const Strikethrough = ({ editor, showLabel = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${editor.isActive('strike') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<StrikethroughOutlined className="text-gray-800 text-xs" />}
      onClick={() => editor.chain().focus().toggleStrike().run()}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="STRIKETHROUGH" defaultMessage="Strikethrough" />
        </div>
      )}
    </Button>
  );
};

export default Strikethrough;
